export const shop = {
  shopByCategory: [
    "Skincare Regimens",
    "Lash & Brow",
    "Eye Creams & Treatments",
    "Face Serums & Treatments",
    "Face Masks",
    "Moisturizers",
    "Cleansers & Makeup Removers",
    "Toners",
    "Sun Protection",
    "Tools & Accessories",
    "Hand & Body",
  ],

  shopByConcern: [
    "Anti-Aging",
    "Acne, Pores & Blackheads",
    "Dark Spots & Uneven Skin Tone",
    "Sensitivity & Visible Redness",
    "Dull & Tired Skin",
    "Dry Skin",
    "Teen Acne",
  ],

  shopByProductLine: [
    "Redefine",
    "Reverse",
    "Unblemish",
    "Soothe",
    "Recharge",
    "Spotless",
    "Enhancements",
    "Pro Skincare Tools",
    "Essentials",
    "All Products",
  ],
};
export const featured = [
  "Special Offers",
  "Before and Afters",
  "New Total RF Serum",
  "Spotless for Teens",
  "Self-Care Essentials",
];
export const ourstory = [
  "R+F Difference",
  "Personalized Service",
  "Explore Our Regimens",
  "Our Founders",
  "Our Impact",
];
export const bestSellers = [
  {
    id: 1,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/ENFM030-Thumbnail-458x458.jpg?context=bWFzdGVyfGltYWdlc3wyNTQ2MHxpbWFnZS9qcGVnfGltYWdlcy9oZmQvaGQ2LzE0ODgyMTk1ODk4Mzk4LmpwZ3wyYThhMjQ0NTc4YjI1ZmQ1ODY3MDE5NGMyYjk3MjA2MTRmNDQ2MzdmOGVhYzMxYTFmMDk1YmIyY2Q5NDhjMzIw",
    product_name: "Total RF Serum",
    description:
      "Our most comprehensive anti-aging serum features RF TriEnergy Complex that energizes millions of surface skin cells by 200% to address all key signs of skin aging.",
    price: 175,
    price_type: "Retail Price",
    ratings: 4.5,
    reviews: 3374,
    images: [
      "https://www.rodanandfields.com/en-us/medias/ENFM030-Global-720x600-Desktop.jpg?context=bWFzdGVyfGltYWdlc3wzNzU0NHxpbWFnZS9qcGVnfGltYWdlcy9oMzQvaDQwLzEzNjkzOTY1NTk4NzUwLmpwZ3xlODg0YWM5YjBiZjM0M2I4MzMyYjE5NDMzMmZjMjg4ZjM1MDE1ZDg4YTI1NjFhNTJlNjg5ZWRjYWYzMTY5NDQ5",
      "https://www.rodanandfields.com/en-us/medias/TRFS-Lifestyle-Product-Global-570x570.jpg?context=bWFzdGVyfGltYWdlc3w1MTE3NnxpbWFnZS9qcGVnfGltYWdlcy9oZDYvaDdlLzEzNjYyODA0NzM4MDc4LmpwZ3w5NDA1Mzc5OGFjOTI1NzU1ZmMyZjlhY2Y0ZjdhNmI4NWU3NmVlMWIxYzY5OWMxNGRlMGIxZjExOWZkNmYyMGNk",
      "https://www.rodanandfields.com/en-us/medias/TRFS-Texture-Global-570x570.jpg?context=bWFzdGVyfGltYWdlc3wxMzI5NnxpbWFnZS9qcGVnfGltYWdlcy9oMGEvaDA4LzEzNjYyODA0ODM2MzgyLmpwZ3w2YjllODQwYjI1YTI2Y2I5YzQ5ZTU0MzMzMzgxNWJiM2I2ZDBkZDIyZGY2YWRhMjA4MTU1MTczYTlkYmEwMjI0",
      "https://www.rodanandfields.com/en-us/medias/TRFS-Application-GIF-Global-570x570.gif?context=bWFzdGVyfGltYWdlc3wxNjcxNDZ8aW1hZ2UvZ2lmfGltYWdlcy9oY2EvaDM0LzEzNjYyODA0NjA3MDA2LmdpZnw3YTUyMTM3ZjZlYzU4NTIwNWJhMWY4ZGYzYmM0NTE4ZWJmMWM3NGZiNTViZDYyNmMyY2JkNzgwZmY2YTg5ZTYw",
    ],
    video: "https://youtu.be/jKIzPp2moeo",
  },
  {
    id: 2,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/ENHLSH01-detail.jpg?context=bWFzdGVyfGltYWdlc3wzMjIzMHxpbWFnZS9qcGVnfGltYWdlcy9oMTMvaDYwLzg4MjE4NDk2ODYwNDYuanBnfDMzOTMxMWRkOGUyMWZiOTQzY2NhYzhlODM4NTFhZDcxZTU3Yzg0NGIyMDZmODE2N2M0YTBhZDUzZDg2MGEyNzI",
    product_name: "R + F Lash Boost",
    description:
      "#1 Premium Lash Serum in the U.S. in 2021!* Our famous lash conditioning serum is applied nightly to promote the appearance of longer, stronger and darker-looking lashes (or brows!)",
    price: 155,
    price_type: "Retail Price",
    ratings: 4.6,
    reviews: 7996,
    images: [
      "https://www.rodanandfields.com/en-us/medias/ENHLSH01-detail.jpg?context=bWFzdGVyfGltYWdlc3wzMjIzMHxpbWFnZS9qcGVnfGltYWdlcy9oMTMvaDYwLzg4MjE4NDk2ODYwNDYuanBnfDMzOTMxMWRkOGUyMWZiOTQzY2NhYzhlODM4NTFhZDcxZTU3Yzg0NGIyMDZmODE2N2M0YTBhZDUzZDg2MGEyNzI",
      "https://www.rodanandfields.com/en-us/medias/ENHLSH01-PDP-lifestyle-1168x1168-DESKTOP.jpg?context=bWFzdGVyfGltYWdlc3w3NTIxNnxpbWFnZS9qcGVnfGltYWdlcy9oYWQvaGQ2Lzg4MjE4NzgwNjMxMzQuanBnfDRlYzBjZmU2ZTg1MDMwMGY3NzYxMGNmMDNiODlkZTJjMGUwOTgxNzdlOGMxODBhNTlkZTNmN2IxMWMzYjhjODE",
    ],
    video: "",
  },
  {
    id: 3,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/ESFB150-1168x1168-desktop-1.jpg?context=bWFzdGVyfGltYWdlc3w1MDMxN3xpbWFnZS9qcGVnfGltYWdlcy9oNTYvaDQ4LzEwMjkxODI5MTc4Mzk4LmpwZ3w3YzAwOGM3MWJkMWRhZDExYjU2NjlkYWY2YjExMmYzNTc3ZmE5ODVmOGFiYWUyM2QzZjlhZWM5YzRkOGZmNzIx",
    product_name: "ESSENTIALS Face + Body Sunscreen Broad Spectrum SPF 50",
    description:
      "Full-body protection. Non-sticky formula provides 80 minutes of water and sweat-resistant broad spectrum SPF 50 protection to help defend against skin-aging UV rays.",
    price: 34,
    price_type: "Retail Price",
    ratings: 4.9,
    reviews: 2929,
    images: [],
    video: "",
  },
  {
    id: 4,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/AAEY015-1168X1168-desktop-1.jpg?context=bWFzdGVyfGltYWdlc3wyNDEyNTJ8aW1hZ2UvanBlZ3xpbWFnZXMvaDczL2g5ZC8xMzUzMzExNzU0NjUyNi5qcGd8NmFhZTU1MjBiMmI2Yjc1YTBjN2JjNjFhZDUwOGQ5OWQ1Zjk0YWI2ZDhlZjViZmQ5ZmMxNzY5MTU0MTFiZDY4ZQ",
    product_name: "REDEFINE Multi-Function Eye Cream",
    description:
      "Younger-looking eyes in a wink! Our intensive anti-aging eye cream visibly firms + lifts to improve the look of fine lines, wrinkles, sagging + crow’s feet.",
    price: 70,
    price_type: "Retail Price",
    ratings: 4.6,
    reviews: 9461,
    images: [
      "https://www.rodanandfields.com/en-us/medias/AAEY015-1168X1168-desktop-1.jpg?context=bWFzdGVyfGltYWdlc3wyNDEyNTJ8aW1hZ2UvanBlZ3xpbWFnZXMvaDczL2g5ZC8xMzUzMzExNzU0NjUyNi5qcGd8NmFhZTU1MjBiMmI2Yjc1YTBjN2JjNjFhZDUwOGQ5OWQ1Zjk0YWI2ZDhlZjViZmQ5ZmMxNzY5MTU0MTFiZDY4ZQ",
      "https://www.rodanandfields.com/en-us/medias/AAEY015-lifestyle-1168x1168-desktop-4.jpg?context=bWFzdGVyfGltYWdlc3wxMjg1OTN8aW1hZ2UvanBlZ3xpbWFnZXMvaGZhL2gwMi8xMzUzMzEyMDk4NzE2Ni5qcGd8ZGQ2ODE0YWE1NDJiZjc2N2IxZjJiNTc4NGQwZmJmYzE2YzUyOWJkNzMzNzQwNzJjYzhjOWExOTg1NTA3ZTg1OQ",
    ],
    video: "",
  },
  {
    id: 5,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/HAAGR-AAWA125-AATN125-AATT030-AAPM030.jpg?context=bWFzdGVyfGltYWdlc3w4Njg1OHxpbWFnZS9qcGVnfGltYWdlcy9oMGIvaDE2LzEzNDI4MDE3NjI3MTY2LmpwZ3w4Yzc5YjRmNWI3YzhmYTUwOWQwYmY3YmFhNTJhYjZlMDBhMGQ4MDFkZjBkY2YwMWFlY2I4YTE2OTY3Nzc2OWY5",
    product_name: "REDEFINE Regimen",
    description:
      "Redefine your skin. Our best selling anti-aging skincare routine visibly lifts, sculpts + firms while minimizing the appearance of lines + deep wrinkles.",
    price: 220,
    price_type: "Retail Price",
    ratings: 4.7,
    reviews: 7311,
    images: [
      "https://www.rodanandfields.com/en-us/medias/HAAGR-AAWA125-AATN125-AATT030-AAPM030.jpg?context=bWFzdGVyfGltYWdlc3w4Njg1OHxpbWFnZS9qcGVnfGltYWdlcy9oMGIvaDE2LzEzNDI4MDE3NjI3MTY2LmpwZ3w4Yzc5YjRmNWI3YzhmYTUwOWQwYmY3YmFhNTJhYjZlMDBhMGQ4MDFkZjBkY2YwMWFlY2I4YTE2OTY3Nzc2OWY5",
      "https://www.rodanandfields.com/en-us/medias/CNVOUB2003-lifestyle-1168x1168-desktop-4.jpg?context=bWFzdGVyfGltYWdlc3wzMzA3NjF8aW1hZ2UvanBlZ3xpbWFnZXMvaGNkL2gxZi8xNDk5NjMxODMyMjcxOC5qcGd8NjY1YzIyNmNhMjQ3OGQ4YTAwNDljZDJiOGU5YTE4MDg3NGM0ZjU0YjVlMjE2ZmIyZWFiMzI1NDI5OGY3NDYyYQ",
    ],
    video: "https://youtu.be/STREOrRvFFg",
  },
  {
    id: 6,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/HUNRJ001-UNWA125-UNTJ125-UNTT030-UNSS030.jpg?context=bWFzdGVyfGltYWdlc3w1OTM4NnxpbWFnZS9qcGVnfGltYWdlcy9oZmMvaDVhLzEyNzcxNjk4NzM3MTgyLmpwZ3w1MzZkNTYzMDJjMzgxYmMwMDZlYjA0ZWQ4ZjMwYTg5ZDIwMzZlMGMzZTA1ZTlmYzJiZTVhOTQxYzMxOTEwMzM2",
    product_name: "UNBLEMISH Regimen",
    description:
      "Bye, breakouts + wrinkles! Our potent skincare routine for adult acne helps clear + prevent breakouts as it visibly minimizes pores + fine lines.",
    price: 190,
    price_type: "Retail Price",
    ratings: 4.4,
    reviews: 463,
    images: [
      "https://www.rodanandfields.com/en-us/medias/HUNRJ001-UNWA125-UNTJ125-UNTT030-UNSS030.jpg?context=bWFzdGVyfGltYWdlc3w1OTM4NnxpbWFnZS9qcGVnfGltYWdlcy9oZmMvaDVhLzEyNzcxNjk4NzM3MTgyLmpwZ3w1MzZkNTYzMDJjMzgxYmMwMDZlYjA0ZWQ4ZjMwYTg5ZDIwMzZlMGMzZTA1ZTlmYzJiZTVhOTQxYzMxOTEwMzM2",
      "https://www.rodanandfields.com/en-us/medias/HUNRJ001-lifestyle-900x900-desktop-4.jpg?context=bWFzdGVyfGltYWdlc3wyNTExMnxpbWFnZS9qcGVnfGltYWdlcy9oMjgvaGZlLzE1MDM4NTk2MzQ5OTgyLmpwZ3wzMDY2MzM0YTg2ODMzM2ZmNmI0ZjRjMWYxZWRkODgyZWUzNWY0ZGM2ODUxMDI3NDc2NzViZTkyZDQ1ODE3M2Jk",
    ],
    video: "https://youtu.be/cCgFFtLsyi4",
  },
  {
    id: 7,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/ENHEFG1-570x570-Desktop.png?context=bWFzdGVyfGltYWdlc3wyMjI3N3xpbWFnZS9wbmd8aW1hZ2VzL2g1NC9oZGUvMTQ1MzIxNjcyMDQ4OTQucG5nfDIwY2RhYjY4NDkwNzYwMTU4Yzg2MjhhYjc0ODVkNWE5MTNjYTIzMzVkOTAxMmFjNzI2M2ZjYzM3ZGM5MzA0ZDY",
    product_name: "R + F Active Hydration Serum",
    description:
      "Quench thirsty skin. Instantly boosts hydration levels by 200% + locks in moisture on the surface of the skin. Add to any Regimen for even better results.",
    price: 112,
    price_type: "Retail Price",
    ratings: 4.8,
    reviews: 8789,
    images: [
      "https://www.rodanandfields.com/en-us/medias/ENHEFG1-570x570-Desktop.png?context=bWFzdGVyfGltYWdlc3wyMjI3N3xpbWFnZS9wbmd8aW1hZ2VzL2g1NC9oZGUvMTQ1MzIxNjcyMDQ4OTQucG5nfDIwY2RhYjY4NDkwNzYwMTU4Yzg2MjhhYjc0ODVkNWE5MTNjYTIzMzVkOTAxMmFjNzI2M2ZjYzM3ZGM5MzA0ZDY",
    ],
    video: "https://youtu.be/Xb-yU_oF-GY",
  },
  {
    id: 8,
    thumb_image:
      "https://www.rodanandfields.com/en-us/medias/ENBR001-detail.jpg?context=bWFzdGVyfHJvb3R8NDA3NjR8aW1hZ2UvanBlZ3xoNzIvaDdmLzEzNTMzMTYyNzk5MTM0LmpwZ3w5ZGQ5MDY2M2ZjM2U4M2NjZmI4OTRiMGU0OGI0YmZjNjRiNDUxM2RkYjNlZDY2MDEzZWU4YWQ4NTc2ZjRiNTA4",
    product_name: "Rodan + Fields Active Hydration Body Replenish",
    description:
      "All-over hydration. Get younger-looking, younger-acting skin with our breakthrough body moisturizer that instantly + continuously hydrates.",
    price: 66,
    price_type: "Retail Price",
    ratings: 4.9,
    reviews: 7129,
    images: [
      "https://www.rodanandfields.com/en-us/medias/ENBR001-detail.jpg?context=bWFzdGVyfHJvb3R8NDA3NjR8aW1hZ2UvanBlZ3xoNzIvaDdmLzEzNTMzMTYyNzk5MTM0LmpwZ3w5ZGQ5MDY2M2ZjM2U4M2NjZmI4OTRiMGU0OGI0YmZjNjRiNDUxM2RkYjNlZDY2MDEzZWU4YWQ4NTc2ZjRiNTA4",
      "https://www.rodanandfields.com/en-us/medias/ENBR001-PDP-lifestyle-1168x1168-DESKTOP.jpg?context=bWFzdGVyfGltYWdlc3w4ODU1OHxpbWFnZS9qcGVnfGltYWdlcy9oN2QvaGI4LzEzNTMzMTYzMzIzNDIyLmpwZ3xhZjg2ODI1Y2E1ZmM0YzM4MTFhOTllYjFmNmFiY2FjMGUyN2Q0NzkxYzcwMzRiNjhhYmExNDY1YzcyZmY0YzRm",
    ],
    video: "https://youtu.be/OskoRVfbEns",
  },
];

export const instaPosts = [
  {
    id: 1,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/63/18192350263192663/low_resolution.jpg",
    status: true,
  },
  {
    id: 2,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/63/17936354605688863/low_resolution.jpg",
    status: true,
  },
  {
    id: 3,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/21/18173775787084721/low_resolution.jpg",
    status: true,
  },
  {
    id: 4,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/51/17914183256051851/low_resolution.jpg",
    status: true,
  },
  {
    id: 5,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/24/17897284883279424/low_resolution.jpg",
    status: true,
  },
  {
    id: 6,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/85/18124584601232185/low_resolution.jpg",
    status: true,
  },
  {
    id: 7,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/80/17889235427243880/low_resolution.jpg",
    status: true,
  },
  {
    id: 8,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/94/17878795901249094/low_resolution.jpg",
    status: true,
  },
  {
    id: 9,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/72/17856529154727072/low_resolution.jpg",
    status: true,
  },
  {
    id: 10,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/69/17869295408638069/low_resolution.jpg",
    status: true,
  },
  {
    id: 11,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/35/18149372425211935/low_resolution.jpg",
    status: true,
  },
  {
    id: 12,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/30/17928229432858630/low_resolution.jpg",
    status: true,
  },
  {
    id: 13,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/58/18145885435212058/low_resolution.jpg",
    status: true,
  },
  {
    id: 14,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/13/17938930987707113/low_resolution.jpg",
    status: true,
  },
  {
    id: 15,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/26/17937476044732026/low_resolution.jpg",
    status: true,
  },
  {
    id: 16,
    img: "https://cdn-yotpo-images-production.yotpo.com/instagram/21/17918148008057821/low_resolution.jpg",
    status: true,
  },
];
